(function() {

  var SECTION_SELECTOR = "[data-custom-collection-list]";
  /** Shopify collection GID numeric id; used when URL has no ?collection_id= */
  var DEFAULT_COLLECTION_ID = "324635558071";
  var COLLECTION_ID_QUERY_KEYS = ["collection_id", "collectionId"];
  var API_ENDPOINT = "https://app.zenheart.world/api/shopify/custom-collection-products";
  var API_TIMEOUT_MS = 20000;
  var API_MAX_RETRY = 1;
  var CACHE_TTL_MS = 120000;
  var AUTOLOAD_OFFSET_PX = 800;
  var EAGER_IMAGE_COUNT = 4;
  var IMAGE_FETCH_WIDTH_DESKTOP = 600;
  var IMAGE_FETCH_WIDTH_MOBILE = 420;
  var IMAGE_LAZY_ROOT_MARGIN = 900;
  var IMAGE_LAZY_CONCURRENCY = 3;
  var MOBILE_SKELETON_COUNT = 4;
  var DEFAULT_SKELETON_COUNT = 8;
  var EARLY_PAGE_SIZE_FALLBACK = 12;
  var inflightRequests = {};
  var earlyFirstPagePrefetch = {
    apiUrl: "",
    done: false,
    promise: null,
    payload: null
  };

  function getByPath(source, path) {
    if (!path) return source;
    var keys = String(path).split(".");
    var cursor = source;
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!key) continue;
      if (cursor == null || typeof cursor !== "object" || !(key in cursor)) {
        return undefined;
      }
      cursor = cursor[key];
    }
    return cursor;
  }

  function toText(value) {
    if (value == null) return "";
    return String(value);
  }

  function escapeHtml(value) {
    return toText(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function withImageWidth(url, width) {
    if (!url) return "";
    try {
      var u = new URL(url, window.location.origin);
      if (!u.searchParams.has("width")) {
        u.searchParams.set("width", String(width));
      }
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function getImageFetchWidth() {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      return IMAGE_FETCH_WIDTH_MOBILE;
    }
    return IMAGE_FETCH_WIDTH_DESKTOP;
  }

  function formatMoney(value) {
    var normalized = value;
    if (typeof value === "string") {
      normalized = value.replace(/[^\d.-]/g, "");
    }
    var raw = Number(normalized || 0);
    if (!isFinite(raw)) raw = 0;
    var amount = raw;
    // /products/{handle}.js often returns integer cents, OMS returns decimal strings like "1188.00".
    var isDecimalString = typeof normalized === "string" && normalized.indexOf(".") !== -1;
    if (!isDecimalString && typeof normalized === "number" && Number.isInteger(normalized)) {
      amount = raw / 100;
    }
    return "NT$" + Math.round(amount).toLocaleString("en-US", { maximumFractionDigits: 0 });
  }

  function formatMoneyHtml(value) {
    var plain = formatMoney(value);
    return plain.replace(/^NT\$/, '<span class="ccp-currency">NT$</span>');
  }

  function buildCardHtml(product, options) {
    var eagerImage = !!(options && options.eagerImage);
    var omitHoverImage = !!(options && options.omitHoverImage);
    var faviconUrl = options && options.faviconUrl ? String(options.faviconUrl) : "";
    var variants = [];
    if (Array.isArray(product && product.variants)) {
      variants = product.variants;
    } else if (product && product.variants && Array.isArray(product.variants.nodes)) {
      variants = product.variants.nodes;
    }
    var firstVariant = variants.length ? variants[0] : null;
    var pricedVariants = variants.filter(function(v) {
      return v && v.price != null && isFinite(Number(v.price));
    });
    var availablePricedVariants = pricedVariants.filter(function(v) {
      return v.availableForSale === true || v.available === true;
    });
    var variantPool = availablePricedVariants.length ? availablePricedVariants : pricedVariants;
    var minPriceVariant = null;
    if (variantPool.length) {
      minPriceVariant = variantPool.reduce(function(min, current) {
        if (!min) return current;
        return Number(current.price) < Number(min.price) ? current : min;
      }, null);
    }
    var mediaNodes = product && product.media && Array.isArray(product.media.nodes) ? product.media.nodes : [];
    var imageNode = product && product.featuredMedia && product.featuredMedia.preview && product.featuredMedia.preview.image
      ? product.featuredMedia.preview.image
      : (mediaNodes[0] && mediaNodes[0].preview ? mediaNodes[0].preview.image : null);
    var hoverNode = mediaNodes[1] && mediaNodes[1].preview ? mediaNodes[1].preview.image : null;
    var image = imageNode && imageNode.url ? imageNode.url : (product && product.featuredImage ? product.featuredImage : (product && product.featured_image ? product.featured_image : ""));
    var secondImage = hoverNode && hoverNode.url ? hoverNode.url : "";
    var imageFetchWidth = getImageFetchWidth();
    image = withImageWidth(image, imageFetchWidth);
    secondImage = withImageWidth(secondImage, imageFetchWidth);
    var imageWidth = imageNode && imageNode.width ? Number(imageNode.width) : 1000;
    var imageHeight = imageNode && imageNode.height ? Number(imageNode.height) : 1000;
    if (!isFinite(imageWidth) || imageWidth <= 0) imageWidth = 1000;
    if (!isFinite(imageHeight) || imageHeight <= 0) imageHeight = 1000;
    var hoverWidth = hoverNode && hoverNode.width ? Number(hoverNode.width) : imageWidth;
    var hoverHeight = hoverNode && hoverNode.height ? Number(hoverNode.height) : imageHeight;
    var title = product && product.title ? product.title : "";
    var handle = product && product.handle ? product.handle : "";
    var url = product && (product.url || product.onlineStoreUrl) ? (product.url || product.onlineStoreUrl) : (handle ? "/products/" + handle : "#");
    var variantPrice = minPriceVariant && minPriceVariant.price != null
      ? minPriceVariant.price
      : (firstVariant && firstVariant.price != null ? firstVariant.price : null);
    var compareAtPriceSource = minPriceVariant && minPriceVariant.compareAtPrice != null
      ? minPriceVariant.compareAtPrice
      : (firstVariant && firstVariant.compareAtPrice != null ? firstVariant.compareAtPrice : null);
    var fallbackPrice = product && product.price != null ? product.price : null;
    var priceSource = variantPrice != null ? variantPrice : fallbackPrice;
    var price = priceSource != null ? formatMoneyHtml(priceSource) : "";
    var compareAtPrice = compareAtPriceSource != null ? formatMoneyHtml(compareAtPriceSource) : "";
    var showCompare = !!compareAtPrice && Number(compareAtPriceSource) > Number(priceSource || 0);
    var titlePriceDividerHtml = "";
    var ratio = (imageWidth / imageHeight).toFixed(4);
    var mainImageHtml = "";
    if (image) {
      mainImageHtml = '<img data-pr-img class="t4s-product-main-img" ' +
        (eagerImage
          ? 'loading="eager" fetchpriority="high" src="' + escapeHtml(image) + '" '
          : 'loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-ccp-src="' + escapeHtml(image) + '" ') +
        'width="' + imageWidth + '" height="' + imageHeight + '" alt="' + escapeHtml(title) + '">';
    }
    var hoverImageHtml = !omitHoverImage && secondImage
      ? '<img data-pr-img2 class="t4s-product-hover-img" loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-ccp-hover-src="' + escapeHtml(secondImage) + '" width="' + hoverWidth + '" height="' + hoverHeight + '" alt="' + escapeHtml(title) + '">'
      : "";

    return (
      '<div class="t4s-product t4s-pr-grid t4s-pr-style1 t4s-col-item">' +
        '<div class="t4s-product-wrapper">' +
          '<div class="t4s-product-inner t4s-pr t4s-oh">' +
            '<div class="t4s-product-img t4s_ratio" style="--aspect-ratioapt:' + ratio + ';">' +
              '<a class="t4s-d-block" href="' + escapeHtml(url) + '">' +
                mainImageHtml +
                hoverImageHtml +
              "</a>" +
            "</div>" +
            '<a class="t4s-full-width-link" href="' + escapeHtml(url) + '"></a>' +
          "</div>" +
          '<div class="t4s-product-info"><div class="t4s-product-info__inner">' +
            '<h3 class="t4s-product-title"><a href="' + escapeHtml(url) + '">' + escapeHtml(title) + "</a></h3>" +
            titlePriceDividerHtml +
            (price
              ? '<div class="t4s-product-price t4s-product-price--card" data-pr-price data-product-price><ins>' + price + '</ins>' +
                (showCompare ? '<del class="t4s-price__compare">' + compareAtPrice + "</del>" : "") +
                "</div>"
              : "") +
          "</div></div>" +
        "</div>" +
      "</div>"
    );
  }

  function resolveCollectionIdFromPage() {
    try {
      var params = new URL(window.location.href).searchParams;
      for (var k = 0; k < COLLECTION_ID_QUERY_KEYS.length; k++) {
        var raw = params.get(COLLECTION_ID_QUERY_KEYS[k]);
        if (raw == null || raw === "") continue;
        var tid = String(raw).trim();
        if (/^\d+$/.test(tid)) return tid;
      }
    } catch (e) {}
    return DEFAULT_COLLECTION_ID;
  }

  function resolveInitialPageSize() {
    try {
      var raw = new URL(window.location.href).searchParams.get("page_size");
      if (raw == null || raw === "") return EARLY_PAGE_SIZE_FALLBACK;
      var parsed = Number(raw);
      if (!isFinite(parsed) || parsed <= 0) return EARLY_PAGE_SIZE_FALLBACK;
      return Math.floor(parsed);
    } catch (e) {
      return EARLY_PAGE_SIZE_FALLBACK;
    }
  }

  function buildApiUrlFromParams(collectionId, page, pageSize) {
    if (!collectionId) return "";
    var url = new URL(API_ENDPOINT, window.location.origin);
    var currentParams = new URL(window.location.href).searchParams;
    function readMultiValueQueryParam(paramName) {
      if (!paramName) return [];
      var values = currentParams.getAll(paramName);
      if (!values || !values.length) return [];
      var result = [];
      values.forEach(function(value) {
        if (value == null) return;
        var normalized = String(value).trim();
        if (!normalized) return;
        // Support both repeated params (?tag=a&tag=b) and delimited single param (?tag=a,b|c).
        normalized
          .split(/[,\|，]/)
          .map(function(part) { return String(part).trim(); })
          .filter(function(part) { return !!part; })
          .forEach(function(part) { result.push(part); });
      });
      return result;
    }
    function copyMultiValueQueryParam(paramName) {
      readMultiValueQueryParam(paramName).forEach(function(part) {
        url.searchParams.append(paramName, part);
      });
    }
    var pinnedProductId = currentParams.get("p_pid");
    if (pinnedProductId) {
      url.searchParams.set("p_pid", pinnedProductId);
    }
    var tags = readMultiValueQueryParam("tag");
    tags.forEach(function(tag) {
      url.searchParams.append("tag", tag);
    });
    if (tags.length) {
      // Compatibility field for backends that prefer a single delimited tags parameter.
      url.searchParams.set("tags", tags.join(","));
      // Allow choosing backend tag logic by URL: ?tag_logic=and|or (default: or).
      var tagLogic = String(currentParams.get("tag_logic") || currentParams.get("tag_mode") || "or").toLowerCase();
      if (tagLogic !== "and" && tagLogic !== "or") tagLogic = "or";
      url.searchParams.set("tag_logic", tagLogic);
    }
    copyMultiValueQueryParam("product_type");
    url.searchParams.set("collection_id", String(collectionId));
    url.searchParams.set("page", String(page));
    url.searchParams.set("page_size", String(pageSize));
    return url.toString();
  }

  function buildApiUrl(cfg, state) {
    return buildApiUrlFromParams(cfg.defaultCollectionId, state.page, cfg.pageSize);
  }

  function maybeStartEarlyFirstPagePrefetch() {
    if (window.__ccpEnableEarlyPrefetch !== true) return;
    if (earlyFirstPagePrefetch.done || earlyFirstPagePrefetch.promise) return;
    var collectionId = resolveCollectionIdFromPage();
    var pageSize = resolveInitialPageSize();
    var apiUrl = buildApiUrlFromParams(collectionId, 1, pageSize);
    if (!apiUrl) return;

    earlyFirstPagePrefetch.apiUrl = apiUrl;
    earlyFirstPagePrefetch.promise = fetch(apiUrl, { method: "POST", credentials: "omit", body: "{}" })
      .then(function(response) {
        if (!response.ok) {
          throw new Error("Early prefetch response error: " + response.status);
        }
        return response.json();
      })
      .then(function(payload) {
        earlyFirstPagePrefetch.payload = payload;
        writeCachedPayload(apiUrl, payload);
        return payload;
      })
      .catch(function() {
        return null;
      })
      .finally(function() {
        earlyFirstPagePrefetch.done = true;
      });
  }

  async function readEarlyPrefetchedPayload(apiUrl) {
    if (!apiUrl || earlyFirstPagePrefetch.apiUrl !== apiUrl) return null;
    if (earlyFirstPagePrefetch.payload) return earlyFirstPagePrefetch.payload;
    if (!earlyFirstPagePrefetch.promise) return null;
    try {
      return await earlyFirstPagePrefetch.promise;
    } catch (e) {
      return null;
    }
  }

  function parseInventoryNumber(value) {
    if (value == null || value === "") return null;
    var num = Number(value);
    return isFinite(num) ? num : null;
  }

  function isProductInStock(product) {
    if (!product || typeof product !== "object") return false;

    // Prefer explicit product-level availability flags when present.
    if (product.availableForSale === false || product.available === false) return false;

    var productLevelInventory = [
      parseInventoryNumber(product.totalInventory),
      parseInventoryNumber(product.inventoryQuantity),
      parseInventoryNumber(product.stock),
      parseInventoryNumber(product.quantityAvailable)
    ];
    for (var i = 0; i < productLevelInventory.length; i++) {
      if (productLevelInventory[i] != null) return productLevelInventory[i] > 0;
    }

    var variants = [];
    if (Array.isArray(product.variants)) {
      variants = product.variants;
    } else if (product.variants && Array.isArray(product.variants.nodes)) {
      variants = product.variants.nodes;
    }
    if (!variants.length) {
      // Strict fallback: without variant/stock breakdown, rely only on explicit availability.
      // If backend didn't provide enough info, treat as out-of-stock to avoid showing sold-out items.
      if (product.availableForSale === true || product.available === true) return true;
      return false;
    }

    var hasExplicitAvailability = false;
    for (var j = 0; j < variants.length; j++) {
      var variant = variants[j];
      if (!variant || typeof variant !== "object") continue;

      if (variant.availableForSale === true || variant.available === true) {
        return true;
      }
      if (variant.availableForSale === false || variant.available === false) {
        hasExplicitAvailability = true;
      }

      var variantInventory = [
        parseInventoryNumber(variant.quantityAvailable),
        parseInventoryNumber(variant.inventoryQuantity),
        parseInventoryNumber(variant.stock)
      ];
      for (var k = 0; k < variantInventory.length; k++) {
        if (variantInventory[k] != null) {
          hasExplicitAvailability = true;
          if (variantInventory[k] > 0) return true;
        }
      }
    }

    // If all explicit availability indicators are out-of-stock, hide it.
    if (hasExplicitAvailability) return false;
    // If no stock info exists at all, keep backward-compatible behavior.
    return true;
  }

  function filterDisplayableProducts(products) {
    if (!Array.isArray(products) || !products.length) return [];
    return products.filter(function(product) {
      if (!product || !product.handle) return false;
      var status = toText(product.status);
      status = status ? status.trim().toUpperCase() : "";
      if (status !== "ACTIVE") return false;
      // Some backends may still mark archived items as ACTIVE.
      if (product.isArchived === true || product.archived === true) return false;
      // Sold out should be excluded when backend provides explicit availability flags.
      if (product.availableForSale === false || product.available === false) return false;
      return isProductInStock(product);
    });
  }

  async function fetchWithTimeout(url, options, timeoutMs) {
    var controller = new AbortController();
    var timer = setTimeout(function() {
      controller.abort();
    }, timeoutMs);
    try {
      var requestOptions = Object.assign({}, options, { signal: controller.signal });
      return await fetch(url, requestOptions);
    } finally {
      clearTimeout(timer);
    }
  }

  function getCacheKey(apiUrl) {
    return "ccp_cache:" + apiUrl;
  }

  function readCachedPayload(apiUrl) {
    try {
      var raw = sessionStorage.getItem(getCacheKey(apiUrl));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !parsed.payload) return null;
      if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
      return parsed.payload;
    } catch (e) {
      return null;
    }
  }

  function writeCachedPayload(apiUrl, payload) {
    try {
      sessionStorage.setItem(getCacheKey(apiUrl), JSON.stringify({ ts: Date.now(), payload: payload }));
    } catch (e) {}
  }

  function requestAnimationFrameAsync() {
    return new Promise(function(resolve) {
      requestAnimationFrame(function() {
        resolve();
      });
    });
  }

  function throttle(fn, wait) {
    var last = 0;
    return function() {
      var now = Date.now();
      if (now - last < wait) return;
      last = now;
      fn();
    };
  }

  function setupLazyImageLoader(rootEl, loaderState) {
    if (!rootEl || !loaderState) return;
    var lazyImgs = rootEl.querySelectorAll("img[data-ccp-src]");
    if (!lazyImgs.length) return;

    var processQueue = function() {
      while (loaderState.inflight < IMAGE_LAZY_CONCURRENCY && loaderState.queue.length) {
        var img = loaderState.queue.shift();
        if (!img || img.getAttribute("data-ccp-loaded") === "1") continue;
        var src = img.getAttribute("data-ccp-src");
        if (!src) continue;
        loaderState.inflight += 1;
        var done = function(target) {
          return function() {
            target.setAttribute("data-ccp-loaded", "1");
            loaderState.inflight = Math.max(0, loaderState.inflight - 1);
            setTimeout(processQueue, 20);
          };
        }(img);
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
        img.setAttribute("src", src);
      }
    };

    var enqueueInDomOrder = function(filterReady) {
      var ordered = rootEl.querySelectorAll("img[data-ccp-src]");
      for (var i = 0; i < ordered.length; i++) {
        var img = ordered[i];
        if (img.getAttribute("data-ccp-loaded") === "1") continue;
        if (img.getAttribute("data-ccp-queued") === "1") continue;
        if (filterReady && img.getAttribute("data-ccp-ready") !== "1") continue;
        img.setAttribute("data-ccp-queued", "1");
        loaderState.queue.push(img);
      }
      processQueue();
    };

    if (!("IntersectionObserver" in window)) {
      enqueueInDomOrder(false);
      return;
    }

    if (!loaderState.observer) {
      loaderState.observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute("data-ccp-ready", "1");
          observer.unobserve(entry.target);
        });
        enqueueInDomOrder(true);
      }, { rootMargin: IMAGE_LAZY_ROOT_MARGIN + "px 0px" });
    }

    for (var j = 0; j < lazyImgs.length; j++) {
      var target = lazyImgs[j];
      if (target.getAttribute("data-ccp-loaded") === "1") continue;
      if (target.getAttribute("data-ccp-observed") === "1") continue;
      target.setAttribute("data-ccp-observed", "1");
      loaderState.observer.observe(target);
    }
  }

  function setupSection(sectionEl) {
    var mockScript = sectionEl.parentElement ? sectionEl.parentElement.querySelector("[data-custom-collection-mock-products]") : null;
    var mockProducts = [];
    if (mockScript) {
      try {
        var parsed = JSON.parse(mockScript.textContent || "[]");
        if (Array.isArray(parsed)) mockProducts = parsed.filter(Boolean);
      } catch (e) {}
    }

    var cfg = {
      defaultCollectionId: resolveCollectionIdFromPage(),
      pageSize: Number(sectionEl.getAttribute("data-page-size") || 12),
      itemsPath: "data.products",
      isDesignMode: sectionEl.getAttribute("data-design-mode") === "true" || !!window.Shopify && !!window.Shopify.designMode,
      mockProducts: mockProducts,
      hasServerRenderedProducts: sectionEl.getAttribute("data-server-rendered-products") === "true",
      sectionId: sectionEl.getAttribute("data-section-id") || "",
      faviconUrl: sectionEl.getAttribute("data-favicon-url") || ""
    };
    function renderMockProducts(products) {
      if (!products || !products.length) return 0;
      var rendered = 0;
      for (var i = 0; i < products.length; i++) {
        var product = products[i];
        if (!product || !product.handle) continue;
        sectionEl.insertAdjacentHTML("beforeend", buildCardHtml(product, { eagerImage: i === 0, omitHoverImage: false, faviconUrl: cfg.faviconUrl }));
        rendered += 1;
      }
      return rendered;
    }


    var root = sectionEl.closest("#shopify-section-" + cfg.sectionId);
    if (!root) return;
    var emptyWrap = root.querySelector("[data-custom-collection-empty]");
    var loadMoreWrap = root.querySelector("[data-custom-collection-loadmore-wrap]");
    var loadMoreBtn = root.querySelector("[data-custom-collection-loadmore-btn]");

    var state = {
      page: 1,
      hasMore: true,
      loading: false,
      // Do not derive from SSR skeleton/design placeholders — that broke prioritizeFirstLoad
      // (!state.initialized && …) so first-visit cards never got omitHoverImage / eager hints.
      initialized: false
    };
    var imageLoaderState = {
      observer: null,
      queue: [],
      inflight: 0
    };

    function showEmpty(show, message) {
      if (!emptyWrap) return;
      emptyWrap.style.display = show ? "" : "none";
      if (message) {
        var txtEl = emptyWrap.querySelector("[data-custom-collection-empty-text]");
        if (txtEl) txtEl.textContent = message;
      }
    }

    function setLoadMoreVisible(visible) {
      if (loadMoreBtn) loadMoreBtn.style.display = visible ? "" : "none";
      if (loadMoreWrap) loadMoreWrap.style.display = visible ? "" : "none";
    }

    function setLoadMoreLoading(loading) {
      if (!loadMoreBtn) return;
      if (!loadMoreBtn.getAttribute("data-default-text")) {
        loadMoreBtn.setAttribute("data-default-text", loadMoreBtn.textContent || "");
      }
      loadMoreBtn.textContent = loading ? "載入中..." : loadMoreBtn.getAttribute("data-default-text");
      loadMoreBtn.disabled = !!loading;
      loadMoreBtn.classList.toggle("is-loading", !!loading);
    }

    function renderSkeleton(count) {
      if (state.initialized || sectionEl.children.length > 0) return;
      var fallbackCount = window.innerWidth <= 768 ? MOBILE_SKELETON_COUNT : DEFAULT_SKELETON_COUNT;
      var safeCount = count > 0 ? count : fallbackCount;
      var html = "";
      for (var i = 0; i < safeCount; i++) {
        html += '<div class="t4s-product t4s-pr-grid t4s-pr-style1 t4s-col-item ccp-skeleton" aria-hidden="true">' +
          '<div class="t4s-product-wrapper">' +
            '<div class="t4s-product-inner t4s-pr t4s-oh">' +
              '<div class="t4s-product-img t4s_ratio" style="--aspect-ratioapt:1;background:#f5f5f5;"></div>' +
            '</div>' +
            '<div class="t4s-product-info"><div class="t4s-product-info__inner">' +
              '<div style="height:14px;background:#f5f5f5;border-radius:3px;margin:8px 0;"></div>' +
              '<div style="height:12px;background:#f0f0f0;border-radius:3px;width:60%;"></div>' +
            '</div></div>' +
          '</div>' +
        '</div>';
      }
      sectionEl.innerHTML = html;
    }

    function clearSkeleton() {
      var skeletons = sectionEl.querySelectorAll(".ccp-skeleton");
      if (!skeletons.length) return;
      sectionEl.innerHTML = "";
    }

    async function renderProducts(products, prioritizeFirstLoad) {
      if (!Array.isArray(products) || !products.length) return 0;
      clearSkeleton();
      var rendered = 0;
      var chunkSize = 4;
      for (var i = 0; i < products.length; i += chunkSize) {
        var batchHtml = "";
        for (var j = i; j < i + chunkSize && j < products.length; j++) {
          var product = products[j];
          if (!product || !product.handle) continue;
          var isFirstBatchCard = prioritizeFirstLoad && rendered < EAGER_IMAGE_COUNT;
          batchHtml += buildCardHtml(product, {
            eagerImage: isFirstBatchCard,
            omitHoverImage: isFirstBatchCard,
            faviconUrl: cfg.faviconUrl
          });
          rendered += 1;
        }
        if (batchHtml) {
          sectionEl.insertAdjacentHTML("beforeend", batchHtml);
          setupLazyImageLoader(sectionEl, imageLoaderState);
          await requestAnimationFrameAsync();
        }
      }
      return rendered;
    }

    function applyPayload(payload) {
      var items = getByPath(payload, cfg.itemsPath);
      var products = Array.isArray(items) ? items : [];
      return products;
    }

    async function loadPage() {
      if (state.loading || !state.hasMore) return;
      state.loading = true;
      setLoadMoreLoading(true);

      try {
        if (cfg.isDesignMode && cfg.mockProducts.length > 0 && !state.initialized) {
          var mockRendered = renderMockProducts(cfg.mockProducts);
          if (!mockRendered) {
            showEmpty(true);
          } else {
            showEmpty(false);
          }
          state.initialized = true;
          state.hasMore = false;
          setLoadMoreVisible(false);
          return;
        }

        var api = buildApiUrl(cfg, state);
        if (!api) {
          state.hasMore = false;
          showEmpty(true, "无法构建商品接口地址。");
          setLoadMoreVisible(false);
          return;
        }
        if (!state.initialized) {
          renderSkeleton(Math.min(cfg.pageSize, 12));
        }
        var earlyPayload = state.page === 1 ? await readEarlyPrefetchedPayload(api) : null;
        var cachedPayload = state.page === 1 ? readCachedPayload(api) : null;
        if (!cachedPayload && earlyPayload) {
          cachedPayload = earlyPayload;
        }
        if (cachedPayload) {
          var cachedProducts = filterDisplayableProducts(applyPayload(cachedPayload));
          if (cachedProducts.length > 0) {
            showEmpty(false);
            await renderProducts(cachedProducts, true);
            var cachedTotal = Number(getByPath(cachedPayload, "data.total") || 0);
            var cachedPage = Number(getByPath(cachedPayload, "data.page") || state.page);
            var cachedPageSize = Number(getByPath(cachedPayload, "data.pageSize") || cfg.pageSize || 0);
            var cachedLoadedCount = cachedPage * cachedPageSize;
            state.hasMore = cachedPageSize > 0 && cachedLoadedCount < cachedTotal;
            state.page = cachedPage + 1;
            state.initialized = true;
            setLoadMoreVisible(state.hasMore);
            return;
          }
        }

        var renderedInThisLoad = 0;
        while (state.hasMore) {
          var currentApi = buildApiUrl(cfg, state);
          var response = null;
          var attempt = 0;
          var requestTimeout = state.initialized ? API_TIMEOUT_MS : 0;
          var requestKey = currentApi + "|POST";
          while (attempt <= API_MAX_RETRY) {
            try {
              if (inflightRequests[requestKey]) {
                response = await inflightRequests[requestKey];
              } else {
                if (requestTimeout > 0) {
                  inflightRequests[requestKey] = fetchWithTimeout(currentApi, { method: "POST", credentials: "omit", body: "{}" }, requestTimeout);
                } else {
                  inflightRequests[requestKey] = fetch(currentApi, { method: "POST", credentials: "omit", body: "{}" });
                }
                response = await inflightRequests[requestKey];
              }
              break;
            } catch (fetchError) {
              attempt += 1;
              if (attempt > API_MAX_RETRY) throw fetchError;
            } finally {
              delete inflightRequests[requestKey];
            }
          }
          if (!response.ok) {
            throw new Error("API response error: " + response.status);
          }
          var payload = await response.json();
          if (state.page === 1) {
            writeCachedPayload(currentApi, payload);
          }
          if (Number(payload && payload.code) !== 0) {
            throw new Error("API business error: " + toText(payload && payload.message));
          }
          var products = filterDisplayableProducts(applyPayload(payload));

          if (products.length > 0) {
            showEmpty(false);
            renderedInThisLoad += await renderProducts(products, !state.initialized && renderedInThisLoad === 0);
            state.initialized = true;
          }

          var totalRaw = getByPath(payload, "data.total");
          var pageRaw = getByPath(payload, "data.page");
          var pageSizeRaw = getByPath(payload, "data.pageSize");
          var total = Number(totalRaw || 0);
          var currentPage = Number(pageRaw || state.page);
          var currentPageSize = Number(pageSizeRaw || cfg.pageSize || 0);
          var loadedCount = currentPage * currentPageSize;
          var hasMore = currentPageSize > 0 && loadedCount < total;
          state.hasMore = hasMore;
          state.page = currentPage + 1;

          // Prevent "blank page" when an API page is fully filtered out.
          if (products.length > 0 || !state.hasMore) {
            break;
          }
        }

        if (!state.initialized) {
          showEmpty(true);
          setLoadMoreVisible(false);
          return;
        }
        setLoadMoreVisible(state.hasMore);
      } catch (error) {
        state.hasMore = false;
        setLoadMoreVisible(false);
        showEmpty(true, "加载超时或失败，请刷新重试。");
      } finally {
        state.loading = false;
        setLoadMoreLoading(false);
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", function() {
        loadPage();
      });
    }

    sectionEl.addEventListener("mouseenter", function(e) {
      var target = e.target;
      if (!target || !target.matches || !target.matches("img[data-ccp-hover-src]")) return;
      if (target.getAttribute("data-ccp-hover-loaded") === "1") return;
      var hoverSrc = target.getAttribute("data-ccp-hover-src");
      if (!hoverSrc) return;
      target.setAttribute("src", hoverSrc);
      target.setAttribute("data-ccp-hover-loaded", "1");
    }, true);

    if (cfg.isDesignMode && cfg.hasServerRenderedProducts) {
      state.hasMore = false;
      setLoadMoreVisible(false);
      showEmpty(false);
      return;
    }

    // Trigger API request as early as possible.
    loadPage();

    var sentinel = document.createElement("div");
    sentinel.setAttribute("data-custom-collection-sentinel", "");
    sentinel.style.height = "1px";
    if (loadMoreWrap && loadMoreWrap.parentNode) {
      loadMoreWrap.parentNode.insertBefore(sentinel, loadMoreWrap);
    } else {
      root.appendChild(sentinel);
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        if (state.hasMore) loadPage();
      }, { rootMargin: AUTOLOAD_OFFSET_PX + "px 0px" });
      observer.observe(sentinel);
    }
  }

  function initCustomCollectionProducts() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;
    sections.forEach(function(sectionEl) {
      if (sectionEl.getAttribute("data-custom-ready") === "1") return;
      sectionEl.setAttribute("data-custom-ready", "1");
      setupSection(sectionEl);
    });
  }

  // Fire first-page request as soon as script executes (doesn't wait for section DOM).
  maybeStartEarlyFirstPagePrefetch();

  // Try immediately for faster first paint on landing sections.
  initCustomCollectionProducts();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initCustomCollectionProducts();
    }, { once: true });
  }
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function() {
      initCustomCollectionProducts();
    });
  }
})();